import BaseModel from "./BaseModel";

export default class PaymentModel extends BaseModel {
  amount: number;
  clientSecret?: string;
  paymentIntentId: string;
  provider: string;
  currency: string;
  status: string;
  country?: string;
  city?: string;
  state?: string;
  street?: string;
  zipcode?: string;

  constructor(arg: any) {
    super(arg);
    this.amount = arg.amount;
    this.clientSecret = arg.client_secret;
    this.paymentIntentId = arg.payment_intent_id;
    this.provider = arg.provider;
    this.currency = arg.currency;
    this.status = arg.status;
    this.country = arg.country;
    this.city = arg.city;
    this.state = arg.state;
    this.street = arg.street;
    this.zipcode = arg.zip;
  }

  get isSuccessful(): boolean {
    return this.status == "successful";
  }
}
